<page-title text="Forgotten Password | BitOasis" i18n-text="@@pageTitle.forgotPassword"></page-title>
<site-layout class="narrow push">
  <h2 class="text-center text-header text-bold mb-2" i18n="@@front.forgotPassword.title">Forgot Password?</h2>
  <p class="text-center text-lg" i18n="@@front.forgotPassword.subtitle">Send reset email</p>
  <div class="p-3"></div>

  <auth-forgot-password></auth-forgot-password>
</site-layout>